import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InscricaoCatequese } from './inscricao';
import { environment } from '../../../environments/environment';

/**
 * `GET /inscricao-catequese/pessoa/{cpf}` — público, como o `POST` da inscrição.
 *
 * `CTR-06` — dois campos e só. O serviço de origem devolve mais, e o backend recorta de
 * propósito: o endpoint é sem token, e devolver cadastro inteiro ampliaria a exposição sem
 * que nenhuma tela precise.
 *
 * `dataNascimento` é **opcional de verdade**, e pode vir nulo com `nome` preenchido: a
 * origem não declara o formato de data que usa, então o backend tenta os formatos conhecidos
 * e devolve nulo quando nenhum casa, em vez de estourar. Data ilegível não invalida o nome.
 */
export interface PessoaPorCpfResposta {
  nome?: string;
  /** `yyyy-MM-dd` — data pura, sem hora nem fuso. */
  dataNascimento?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class InscricaoService {
  private baseUrl = `${environment.api}/inscricao-catequese`;

  constructor(private http: HttpClient) {}

  /**
   * Quem consulta o serviço de origem é o backend — aqui não há URL de terceiro nem
   * credencial (`STK-09`, `STK-08`).
   *
   * Erros que a tela precisa distinguir: `404` é "este CPF não tem cadastro"; `502` é "não
   * consegui consultar" — origem fora do ar, credencial recusada ou token não configurado no
   * ambiente. Nenhum dos dois bloqueia o cadastro (`FRM-07`).
   */
  buscarPorCpf(cpf: string): Observable<PessoaPorCpfResposta> {
    const cpfLimpo = cpf.replace(/\D/g, '');
    return this.http.get<PessoaPorCpfResposta>(`${this.baseUrl}/pessoa/${encodeURIComponent(cpfLimpo)}`);
  }

  enviarInscricao(inscricao: InscricaoCatequese): Observable<void> {
    return this.http.post<void>(this.baseUrl, inscricao);
  }
}